module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"author":"作者：","published_at":"发布时间：","copy_success":"文章链接复制成功，发送给好友吧！","copy_error":"复制时出错","share":"分享"},"en":{"author":"Author:","published_at":"Published at:","copy_success":"Article link copied successfully, share it with your friends!","copy_error":"Copy failed","share":"Share"}}')
  delete Component.options._Ctor
}
